/** 轮播间隔 (ms) */
export const AUTO_PLAY_INTERVAL = 3500;

/** 主题色 */
export const THEME = {
  primary: "#FF6B35",
  primaryLight: "#FFF0EB",
  primaryBorder: "#FFD9CE",
  text: "#374151",
  textSecondary: "#9CA3AF",
  star: "#F59E0B",
  success: "#22C55E",
};

/** 星期映射 */
export const WEEK_MAP: Record<string, string> = {
  "1": "周一", "2": "周二", "3": "周三", "4": "周四",
  "5": "周五", "6": "周六", "7": "周日", "0": "每天",
};
